<template>
  <Fieldset ref="fieldset" :legend="legend" :toggleable="toggleable" :collapsed="collapsed">
    <template #legend>
      <slot name="legendSlot"></slot>
    </template>
    <slot />
  </Fieldset>
</template>

<script>
import EventBus from "@/commons/EventBus";

export default {
  name: "CardFieldset",

  props: {
    legend: String,
    toggleable: {type: Boolean, default: true},
    collapsed: {type: Boolean, default: false},
    referenceId: {type: String, default: ''},
  },

  mounted() {
    this.$refs.fieldset.$on('update:collapsed', this.changedCollapsed);
  },

  methods: {

    changedCollapsed(collapsed){
      EventBus.$emit('update:collapsed', {referenceId: this.referenceId, collapsed})
    }

  },

}
</script>

<style scoped>

</style>